import { useIntl } from 'Features/Intl/context';
import { createIntlTranslations } from 'Features/Intl/fns';
import { Layout } from 'Features/Shared/Components/Layout';
import { GetServerSidePropsContext } from 'next';
import { NextSeo } from 'next-seo';

export default function Page() {
  const { route, __ } = useIntl();

  return (
    <Layout>
      <NextSeo title={__('meta.title')} description={__('meta.description')} />

      {/* Content */}
      <div className="max-w-7xl mx-auto min-h-[calc(100vh-6rem)] px-6">
        <div className="mx-auto max-w-2xl py-32 sm:py-24">
          <div className="text-center">
            <h1 className="text-4xl font-space font-bold tracking-tight text-slate-900 sm:text-6xl">
              {route.sections.hero.title}
            </h1>
            <p className="mt-6 text-lg leading-8 text-slate-600">{route.sections.hero.subtitle}</p>
          </div>
        </div>

        <div className="space-y-12">
          {route.sections.clusters.map((cluster: any, idx: number) => (
            <section key={idx}>
              <h3 className="text-sm font-semibold leading-7 text-slate-400">{cluster.title}</h3>
              <dl className="mt-2 divide-y divide-slate-100">
                {cluster.items.map((item: any, idx: number) => (
                  <details key={idx} className="group py-4 marker:content-[''] marker:hidden">
                    <summary className="flex w-full cursor-pointer select-none justify-between text-left text-base font-semibold leading-7 text-slate-900 group-open:text-indigo-600 [&amp;::-webkit-details-marker]:hidden">
                      {item.question}
                      <svg
                        className="ml-4 mt-0.5 h-6 w-6 flex-none stroke-slate-700 group-open:stroke-indigo-500"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                        strokeWidth="2"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      >
                        <path d="M18 12H6"></path>
                        <path className="group-open:hidden" d="M12 6v12"></path>
                      </svg>
                    </summary>
                    <div className="pb-6 pt-6">
                      <div className="prose prose-slate max-w-none prose-a:font-semibold prose-a:text-indigo-600 hover:prose-a:text-indigo-500">
                        <p>{item.answer}</p>
                      </div>
                    </div>
                  </details>
                ))}
              </dl>
            </section>
          ))}
        </div>
      </div>
    </Layout>
  );
}

export async function getServerSideProps(context: GetServerSidePropsContext) {
  const locale = context.locale?.startsWith('it') ? 'it' : 'en';
  const intl = await createIntlTranslations(locale, 'faq');

  return {
    props: { ...intl },
  };
}
